/**
 * What a visitor can allow, and what each choice actually switches.
 *
 * The keys are the contract between the CMS (which owns the words) and this app
 * (which owns the behaviour). A category the CMS invents that is not here has no
 * effect, which is why the CMS field is an enumeration rather than free text.
 */
export const CONSENT_CATEGORIES = [
  "necessary",
  "functional",
  "analytics",
  "marketing",
] as const;

export type ConsentCategory = (typeof CONSENT_CATEGORIES)[number];

/** What the visitor decided. `necessary` is not a choice, so it is not stored. */
export type ConsentChoices = Record<
  Exclude<ConsentCategory, "necessary">,
  boolean
>;

export interface ConsentRecord {
  choices: ConsentChoices;
  /** Categories the visitor was actually ASKED about, so a category added later
   * can be spotted and asked about rather than silently assumed. The privacy
   * policy promises exactly that. */
  asked: ConsentCategory[];
  /** Milliseconds. Load-bearing: `readConsent` compares it to decide between a
   * stored answer and one a store refused to keep. */
  decidedAt: number;
}

export const NOTHING_ALLOWED: ConsentChoices = {
  functional: false,
  analytics: false,
  marketing: false,
};

export const EVERYTHING_ALLOWED: ConsentChoices = {
  functional: true,
  analytics: true,
  marketing: true,
};
